module.exports = __webpack_public_path__ + "img/zh_cn.ba2066e8.png";